import React, { useEffect, useState } from "react";
import { instance2 } from "../../utils/axiosInstance";
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";
import { ReactComponent as PlusIcon } from "../../img/plusicon.svg";
import { ReactComponent as VerticalLine } from '../../img/verticalline.svg'
import { ReactComponent as MagnificationLogo } from '../../img/magnificationlensicon.svg'
import { ReactComponent as FilterLogo } from '../../img/filtericon.svg'
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from 'react-router-dom'
import { EyeIcon } from '@heroicons/react/16/solid';
import { formatNumber } from "src/components/numberingformat";

export default function InputRecipes() {

  const navigate = useNavigate()
  const roleId = parseInt(localStorage.getItem("roleId"),10)
  const [data, setData] = useState([]);
  const [ingredients, setIngredients] = useState([]); // Store ingredients from /ingredient_master
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [isModalEditOpen, setIsModalEditOpen] = useState(false);
  const [currentDish, setCurrentDish] = useState(null);
  const [currentDishId, setCurrentDishId] = useState(null);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
          const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
          const itemsPerPage = 10; // Number of items per page
  const [newRecipeData, setNewRecipeData] = useState({
    dish_id: "",
    ingredient_id: "",
    qty: "",
    uoq_id: "",
    uoq_name: "", // Add this field to store the name of the unit of quantity
    note: "",
    admin_id: localStorage.getItem("userAuthentication") || "",
  });
    const [searchQuery, setSearchQuery] = useState(""); // State for search input
    const [categories, setCategories] = useState([]); // Store categories from API
    const [editFormData, setEditFormData] = useState({
      dish_id:"",
      dish_name: "",
      category_id: "", // Store category_id instead of name
      description: "", // Store category_id instead of name
    });

  const [formDataTambah, setFormDataTambah] = useState({
    name: "",
    category_id: "", // Store category_id instead of name
    description: "", // Store category_id instead of name
    admin_id: localStorage.getItem("UserAuthentication"),
  }); 
    const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" }); // Sort state


  const [categoriesTambah, setCategoriesTambah] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [categoriesError, setCategoriesError] = useState(null);


  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoadingCategories(true);
        setCategoriesError(null);
        // Replace 'categories' with your actual API endpoint for categories
        const response = await instance2.get("dish_category");
        const apiCategories = response.data?.data || response.data || [];
        setCategoriesTambah(apiCategories);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategoriesError(error.message || "Failed to fetch categories");
      } finally {
        setLoadingCategories(false);
      }
    };
  
    fetchCategories();
  }, []);

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const recipesResponse = await instance2.get("recipes");
        const recipesData = recipesResponse.data?.data || recipesResponse.data || [];
        if (!Array.isArray(recipesData)) {
          throw new Error("Invalid API response structure for recipes.");
        }
        setData(recipesData);

        const ingredientsResponse = await instance2.get("ingredient_master");
        const ingredientsData = ingredientsResponse.data?.data || ingredientsResponse.data || [];
        if (!Array.isArray(ingredientsData)) {
          throw new Error("Invalid API response structure for ingredients.");
        }
        setIngredients(ingredientsData);
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Handle edit button click
  const handleEditClick = async (dish_id, dish_name) => {
    try {
      const response = await instance2.get(`recipes/${dish_id}`);
      const result = response.data?.data || response.data || [];
      
      // If no data is returned, initialize an empty modal state
      if (result.length === 0) {
        setModalData([]);
        setCurrentDish(dish_name); // Default title
        setCurrentDishId(dish_id); // Default title
        setNewRecipeData((prev) => ({
          ...prev,
          dish_id,
          note: "", // No steps available
        }));
      } else {
        // Populate modal with fetched data
        setModalData(result);
        setCurrentDish(result[0]?.dish_name || "Dish");
        setCurrentDishId(result[0]?.dish_id || "Dish");
        setNewRecipeData((prev) => ({
          ...prev,
          dish_id,
          note: result[0]?.step || "", // Assuming `step` holds the note text
        }));
      }
  
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching dish details:", error);
      alert("Failed to fetch dish details. Opening an empty modal.");
      setModalData([]); // Initialize with an empty state
      setCurrentDish("Dish"); // Default title
      setNewRecipeData((prev) => ({
        ...prev,
        dish_id,
        note: "", // No steps available
      }));
      setIsModalOpen(true); // Open modal even on failure
    }
  };
  
  

  // Handle delete button in modal
  const handleDeleteRow = async (id) => {
    if (!window.confirm("Are you sure you want to delete this ingredient?")) {
      return;
    }

    try {
      const response = await instance2.delete(`recipes/${id}`);
      console.log(response)
      if (response.status === "OK") {
        setModalData((prevData) => prevData.filter((item) => item.id !== id));
        alert("Ingredient deleted successfully.");
      } else {
        throw new Error("Failed to delete the ingredient.");
      }
    } catch (error) {
      console.error("Error deleting ingredient:", error.message || error.response?.data);
      alert("Error deleting ingredient. Please try again.");
    }
  };
  // Handle add new row in modal
  const handleAddRow = () => {
    const newRow = {
      id: Date.now(), // Temporary unique ID
      ingredient_name: "",
      qty: "",
      uoq_code: "",
    };
    setModalData((prevData) => [...prevData, newRow]);
  };

  // Handle field edits in modal
  const handleEditField = (id, field, value) => {
    setModalData((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  // Handle adding a new recipe
  const handleAddRecipe = async () => {
    try {
      const response = await instance2.post("recipes", newRecipeData);
  
      if (response.status === "OK") {
        //alert("Recipe added successfully!");
  
        
      // Fetch the newly added ingredient directly (optional, if your API supports it)
      const ingredient = ingredients.find(
        (ing) => ing.id === parseInt(newRecipeData.ingredient_id, 10)
      );

      const newEntry = {
        id: Date.now(), // Temporary ID
        ingredient_name: ingredient?.ingredient_name || "-",
        qty: newRecipeData.qty,
        uoq_code: newRecipeData.uoq_name || "-",
      };

      // Append the new entry locally instead of re-fetching all
      setModalData((prev) => [...prev, newEntry]);

      // Reset form
      setNewRecipeData((prev) => ({
        ...prev,
        ingredient_id: "",
        qty: "",
        uoq_id: "",
        uoq_name: "",
        note: "", // Optional: preserve or reset depending on use
      }));

      setIsAddModalVisible(false);
      } else {
        throw new Error(response.data.message || "Failed to add recipe.");
      }
    } catch (error) {
      console.error("Error adding recipe:", error.message || error.response?.data);
      alert("Error adding recipe. Please try again.");
    }
  };
  
  
  const handleIngredientChange = (ingredient_id) => {
    const selectedIngredient = ingredients.find((item) => item.id === parseInt(ingredient_id, 10));
    setNewRecipeData((prev) => ({
      ...prev,
      ingredient_id,
      uoq_id: selectedIngredient?.uoq_id || "",
      uoq_name: selectedIngredient?.uoq_name || "", // Update the name
    }));
  };
  const handleSaveText = async () => {
    try {
      if (!currentDish) {
        alert("No dish selected to save the step for.");
        return;
      }
  
      const payload = {
        step: newRecipeData.note, // Send the text editor value as `step`
        admin_id: localStorage.getItem("userAuthentication") || "", // Include admin_id
      };
  
      const response = await instance2.post(`recipe_step/${newRecipeData.dish_id}`, payload);
  
      if (response.status === "OK") {
        alert("Step saved successfully!");
      } else {
        throw new Error("Failed to save step.");
      }
    } catch (error) {
      console.error("Error saving step:", error.message || error.response?.data);
      alert("Error saving step. Please try again.");
    }
  };
  
  
  const stripHtmlTags = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };
  
  
  const filteredData = data.filter((item) => {
    const searchValue = searchQuery.toLowerCase();
  
    return (
      (item.dish_name?.toLowerCase() || "").includes(searchValue) || // Check if dish_name matches
      (item.category_name?.toLowerCase() || "").includes(searchValue) || // Check if district_name matches
      (item.description?.toLowerCase() || "").includes(searchValue)
    );
  });
  // Render loading or error state
  if (loading) return <p className="text-center text-gray-500">Loading...</p>;
  if (error) return <p className="text-center text-red-500">Error: {error}</p>;

 // Pagination logic
 const totalPages = Math.ceil(filteredData.length / itemsPerPage);
 const paginatedData = filteredData.slice(
   (currentPage - 1) * itemsPerPage,
   currentPage * itemsPerPage
 );

 const handlePreviousPage = () => {
   if (currentPage > 1) setCurrentPage(currentPage - 1);
 };

 const handleNextPage = () => {
   if (currentPage < totalPages) setCurrentPage(currentPage + 1);
 };
 
 const handleSaveEdit = async (dish_id) => {
  try {
    const payload = {
      name: editFormData.dish_name,
      category_id: editFormData.category_id,
      description: editFormData.description,
    };

    const response = await instance2.put(`dishes/${dish_id}`, payload);
    console.log("response", payload)
    if (response.status === "OK") {
      //alert("Recipe updated successfully!");
      setIsModalEditOpen(false);
      window.location.reload();

      // Refresh the data
      const updatedData = await instance2.get("recipes");
      setData(updatedData.data?.data || []);
    } else {
      throw new Error("Failed to update recipe.");
    }
  } catch (error) {
    console.error("Error updating recipe:", error);
    alert("Error updating recipe. Please try again.");
  }
};

const handleOpenEditModal = async (dish_id) => {
  try {
    // Fetch dish details for editing
    const response = await instance2.get(`dishes/${dish_id}`);
    const result = response.data?.data || response.data || [];
    console.log("result", result)
    if (!result.length) {
      throw new Error("Invalid recipe data.");
    }

    const dishDetails = result[0];

    // Fetch categories
    const categoriesResponse = await instance2.get("dish_category");
    const categoriesData = categoriesResponse.data?.data || categoriesResponse.data || [];

    if (!Array.isArray(categoriesData)) {
      throw new Error("Invalid categories data.");
    }

    setCategories(categoriesData); // Store available categories

    // Set modal form data
    setEditFormData({
      dish_id: dishDetails.id || "",
      dish_name: dishDetails.dish_name || "",
      category_id: dishDetails.category_id || "", // Assuming API returns category_id
      description: dishDetails.description || "", // Assuming API returns category_id
    });

    setIsModalEditOpen(true);
  } catch (error) {
    console.error("Error fetching dish details:", error);
    alert("Failed to fetch dish details.");
  }
};

  const handleSort = (key) => {
    const newDirection =
      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return newDirection === "asc" ? -1 : 1;
      if (a[key] > b[key]) return newDirection === "asc" ? 1 : -1;
      return 0;
    });
    setData(sortedData);
    setSortConfig({ key, direction: newDirection });
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "▲" : "▼";
    }
    return "";
  };

const handleChange = (e) => {
  const { name, value } = e.target;
  
  // Only apply transformation for the dish_name field.
  const transformedValue =
    name === "name"
      ? value
          .split(" ")
          .map((word) =>
            word.length > 0
              ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              : ""
          )
          .join(" ")
      : value;

  setFormDataTambah((prev) => ({
    ...prev,
    [name]: transformedValue,
  })); 
};

const isFormValid = () => {
  return (
    formDataTambah.name.trim() !== "" &&
    formDataTambah.category_id !== "" &&
    formDataTambah.description.trim() !== ""
  );
};

 const handleSubmitTambah = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
  
    try {
      const response = await instance2.post("dishes", formDataTambah);
  
      console.log("Success:", response.data);
  
      // Refresh the page after successful submission
      window.location.reload();
    } catch (error) {
      console.error("Error:", error);
    }
  };

    // Determine which page numbers to show
    let pageNumbers = [];
    const maxVisiblePages = 5;
  
    if (totalPages <= maxVisiblePages) {
      pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      if (currentPage <= 3) {
        // Near the beginning
        pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        // Near the end
        pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
      } else {
        // In the middle
        pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
      }
    }


  return (
    <div className="p-4">
      
    <div className="flex flex-col items-start md:flex-row lg:flex-row md:items-center lg:items-center justify-between">
    <h2 className="block text-black text-xl sm:text-2xl my-2 font-medium">Daftar Resep</h2>
    <div className="flex flex-row gap-8">
    <div className="flex flex-row gap-4">
        <button
          type="button"
          onClick={() => navigate('/tambahmenu')} // Wrap navigate in an arrow function
          className="rounded-[25px] px-8 py-4 bg-merah-no hover:bg-merah-hover text-white text-xxs md:text-xxs lg:text-base"
        >
          Tambah Makanan
        </button>
        </div>
    <div className="flex flex-row gap-4">
        <button
          type="button"
          onClick={() => navigate('/uploadresep')} // Wrap navigate in an arrow function
          className="rounded-[25px] px-8 py-4 bg-merah-no hover:bg-merah-hover text-white text-xxs md:text-xxs lg:text-base"
        >
          Tambah Resep
        </button>
        </div>
        </div>
    </div>
      {/* Search Bar */}
      
            { data.length === 0 ? (
              <p className="text-center text-gray-500">Belum ada data</p>
            ) : (
              <div>
          <div className="flex py-4 rounded-[50px] flex-row justify-start items-center gap-2">
            <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center justify-start">
              <MagnificationLogo className="h-6 w-6" />
              <VerticalLine className="mx-1" />
              <input
                type="text"
                placeholder="Telusuri data berdasarkan nama makanan atau kategori"
                className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-xxs md:text-xxs lg:text-base"
                style={{
                  width: `${"Telusuri data berdasarkan nama makanan atau kategori".length}ch`,
                }}
                value={searchQuery} // Controlled input
                onChange={(e) => setSearchQuery(e.target.value)} // Update search query
              />
            </div>
            
            {/* Filter Icon */}
            {/* <div className="text-gray-400">
              <FilterLogo />
            </div> */}
            </div>
      <table className="table-fixed border-collapse w-full text-left">
        <thead>
          <tr className="bg-white">
            <th className="w-[25px] lg:w-[50px]  border-b border-gray-300 px-4 py-2 cursor-pointer rounded-tl-[15px] text-sm text-xxs md:text-xxs lg:text-base">No.</th>
                <th
                  className="border-b px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
                  onClick={() => handleSort("dish_name")}
                >
                  Nama Makanan <span className="float-right">{getSortArrow("dish_name")}</span>
                </th>
                <th
                  className="border-b border-gray-300 px-4 py-2 text-center cursor-pointer text-sm text-xxs md:text-xxs lg:text-base"
                  onClick={() => handleSort("category_name")}
                >
                  Kategori <span className="float-right">{getSortArrow("category_name")}</span>
                </th>
             {/* <th className="border-b border-gray-300 px-4 py-2 text-center cursor-pointer text-sm text-xxs md:text-xxs lg:text-base">Deskripsi</th> */}
            <th className="border-b border-gray-300 px-4 py-2 rounded-tr-[15px] text-center text-sm text-xxs md:text-xxs lg:text-base">Aksi</th>
          </tr>
        </thead>
        <tbody>
                  {[
            ...paginatedData,
            ...Array.from({ length: itemsPerPage - paginatedData.length }).map((_, index) => ({
              empty: true, // Add an "empty" object for invisible rows
            })),
          ].map((item, index) => (
            <tr
            key={item.id}
            className={`hover:bg-gray-200 ${
              index % 2 === 0 ? "bg-bg-gray-100" : "bg-white"
            } ${item.empty ? "invisible border-b border-transparent" : "border-b border-gray-300"}`}
          >
              <td className="w-[25px] lg:w-[50px]  px-4 py-2 text-xxs md:text-xxs lg:text-base">  {index + 1 + (currentPage - 1) * itemsPerPage}</td>
              <td className="px-4 py-2 text-xxs md:text-xxs lg:text-base">{item.dish_name}</td>
              <td className="px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">{item.category_name}</td>
              {/* <td className="px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">{item.description}</td> */}
              {/* <td className="border-b border-gray-300 px-4 py-2">
  {stripHtmlTags(item.steps)}
</td> */}

              <td className="px-4 py-2 text-center">
                <button
                  className="text-gray-500 p-2 rounded hover:text-blue-500"
                  onClick={() => handleEditClick(item.id, item.dish_name)}
                >
                  <EyeIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                </button>
                {roleId === 2 ? (
                <button
                  className="text-gray-500 p-2 rounded hover:text-blue-500"
                  onClick={() => handleOpenEditModal(item.id)}
                >
                  <EditIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                </button>):("")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

        {/* Pagination Controls */}
<div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>
              </div>
            )}
      {/* Modal */}
      {isModalOpen && (
        <div
        className=" flex fixed inset-0 bg-black bg-opacity-50 justify-center items-center"
        style={{ overflowY: "auto" }} // Allow scrolling for the modal if it overflows the screen
      >
         <div
    className="bg-white p-6 rounded-lg max-w-5xl w-full flex gap-6"
    style={{
      maxHeight: "90vh", // Maximum height is 90% of the viewport height
      overflowY: "auto", // Enable vertical scrolling when content overflows
    }}
  >  {/* Left Column: Table */}
          <div className="flex-1">
                <h2 className="text-xl font-bold mb-4">Ubah Resep: {currentDish}</h2>
                <table className="table-auto border-collapse w-full text-left mb-4">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="border border-gray-400 px-4 py-2">Nama Bahan</th>
                      <th className="border border-gray-400 px-4 py-2">Jumlah</th>
                      <th className="border border-gray-400 px-4 py-2">Unit</th>
                      <th className="border border-gray-400 px-4 py-2">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
        {modalData.length > 0 ? (
          modalData.map((ingredient) => (
            <tr key={ingredient.id} className="odd:bg-white even:bg-gray-50">
              <td className="border border-gray-400 px-4 py-2">{ingredient.ingredient_name || "-"}</td>
              <td className="border border-gray-400 px-4 py-2 text-right">{formatNumber(ingredient.qty) || "-"}</td>
              <td className="border border-gray-400 px-4 py-2">{ingredient.uoq_code || "-"}</td>
              <td className="border border-gray-400 px-4 py-2">
                {/* <button
                  className="text-gray-500 p-1 rounded hover:text-green-500"
                  onClick={() =>
                    handleEditField(
                      ingredient.id,
                      "ingredient_name",
                      prompt("Edit ingredient name:", ingredient.ingredient_name)
                    )
                  }
                >
                  <EditIcon className="w-5 h-5" />
                </button> */}
                <button
                  className="text-gray-500 p-1 rounded hover:text-red-500"
                  onClick={() => handleDeleteRow(ingredient.id)}
                >
                  <TrashIcon className="w-5 h-5" />
                </button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="4" className="text-center text-gray-500 py-4">
              No ingredients available.
            </td>
          </tr>
        )}

      </tbody>
          </table>
          <div className="flex flex-row w-full items-center justify-evenly">
          <div className=" text-center"> 
          <button
            className="px-4 py-2 bg-merah-no text-white rounded hover:bg-merah-hover mb-4"
            onClick={() => setIsModalOpen(false)}
          >
            Tutup
          </button>
          </div>
                   <div className=" text-center">
             {roleId === 2 || roleId === 5 ? (
          <button
            className="bg-merah-no text-white px-4 py-2 rounded hover:bg-merah-hover mb-4"
            onClick={() =>                     
              navigate("/uploadresep", {
              state: {
                newDishId: currentDishId, // ID of newly created dish
                newDishName: currentDish, // Display name of the dish
              },
            })
            }
          >
            Upload CSV
          </button>):("")}
          </div> 
          <div className=" text-center">
             {roleId === 2 || roleId === 5 ? (
          <button
            className="bg-merah-no text-white px-4 py-2 rounded hover:bg-merah-hover mb-4"
            onClick={() => setIsAddModalVisible(true)}
          >
            Tambah
          </button>):("")}
          </div>
          </div>
          </div>
           {/* Right Column: Text Editor */}
           <div className="flex-1 flex flex-col h-full">
  <h2 className="text-xl font-bold mb-4">Langkah Pembuatan</h2>
  <div className="flex-1">
  <ReactQuill
  value={newRecipeData.note}
  onChange={(value) =>
    setNewRecipeData((prev) => ({ ...prev, note: value }))
  }
  className="h-full"
/>
  </div>
  

<div className="w-full text-center py-2">  </div>
  <div className="w-full text-center">
    {roleId === 2  || roleId === 5 ? (
  <button
    onClick={handleSaveText}
    className="bg-merah-no text-white px-4 py-2 rounded hover:bg-merah-hover w-1/2"
  >
    Simpan
  </button>
  ):("")}
  </div>
</div>

        </div>
      </div>
      
      )}
      {/* Edit Modal */}
      {isModalEditOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
    <div className="bg-white p-6 rounded-lg w-96">
      <h2 className="text-xl font-bold mb-4">Ubah Makanan</h2>
      
      {/* Dish Name Input */}
      <label className="block mb-2">Nama Makanan:</label>
      <input
        type="text"
        className="w-full border p-2 rounded mb-4"
        value={editFormData.dish_name}
        onChange={(e) => setEditFormData({ ...editFormData, dish_name: e.target.value })}
      />

      {/* Category Dropdown */}
      <label className="block mb-2">Kategori:</label>
      <select
        className="w-full border p-2 rounded mb-4"
        value={editFormData.category_id}
        onChange={(e) => setEditFormData({ ...editFormData, category_id: e.target.value })}
      >
        <option value="" disabled>Pilih Kategori</option>
        {categories.map((category) => (
          <option key={category.id} value={category.id}>
            {category.name} {/* Assuming API returns 'id' and 'name' */}
          </option>
        ))}
      </select>

      {/* Description Input */}
      <label className="block mb-2">Deskripsi:</label>
      <textarea
        className="w-full border p-2 rounded mb-4 h-24"
        value={editFormData.description}
        onChange={(e) => setEditFormData({ ...editFormData, description: e.target.value })}
        placeholder="Tambahkan deskripsi resep..."
      />

      {/* Save Button */}
      <button
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 w-full"
        onClick={() => handleSaveEdit(editFormData.dish_id)}
      >
        Simpan
      </button>

      {/* Close Button */}
      <button
        className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 w-full mt-2"
        onClick={() => setIsModalEditOpen(false)}
      >
        Batal
      </button>
    </div>
  </div>
)}

      {/* Add Modal */}
      {isAddModalVisible && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-[500px]">
            <h2 className="text-xl font-bold mb-4">Tambah Resep Baru</h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleAddRecipe();
              }}
            >
              <div className="mb-4">
                <label className="block text-gray-700">Makanan</label>
                <select
                  value={newRecipeData.dish_id || ""}
                  className="w-full px-4 py-2 border rounded-lg bg-gray-100"
                  disabled
                >
                  <option value="" disabled>
                    Pilih Makanan
                  </option>
                  {data.map((dish) => (
                    <option key={dish.id} value={dish.id}>
                      {dish.dish_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Bahan Baku</label>
                <select
                  value={newRecipeData.ingredient_id || ""}
                  onChange={(e) => handleIngredientChange(e.target.value)}
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                >
                  <option value="" disabled>
                    Select Ingredient
                  </option>
                  {ingredients.map((ingredient) => (
                    <option key={ingredient.id} value={ingredient.id}>
                      {ingredient.ingredient_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Jumlah</label>
                <input
                  type="number"
                  value={newRecipeData.qty}
                  onChange={(e) =>
                    setNewRecipeData((prev) => ({ ...prev, qty: e.target.value }))
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                />
              </div>
              <div className="mb-4">
  <label className="block text-gray-700">Unit of Quantity</label>
  <input
    type="text"
    value={newRecipeData.uoq_name} // Show the `uoq_name` to the user
    className="w-full px-4 py-2 border rounded-lg bg-gray-100"
    readOnly // Ensure this field is readonly
  />
</div>

              {/* <div className="mb-4">
                <label className="block text-gray-700">Note</label>
                <textarea
                  value={newRecipeData.note}
                  onChange={(e) =>
                    setNewRecipeData((prev) => ({ ...prev, note: e.target.value }))
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                />
              </div> */}
              <div className="flex justify-end gap-4">
                <button
                  type="button"
                  className="bg-merah-no text-white px-4 py-2 rounded hover:bg-merah-hover"
                  onClick={() => setIsAddModalVisible(false)}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  className="bg-merah-no text-white px-4 py-2 rounded hover:bg-merah-hover"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
